import styled, { css } from 'styled-components'
import img from '../../images/common/icon/bg_title_q.svg'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  padding: 0 24px;
  &:nth-child(1) {
    margin-top: 28px;
  }
`

export const SectionTitle = styled.div`
  h4 {
    opacity: 0.9;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 1px;
    color: #585858;
    position: relative;
    margin-bottom: 24px;

    &:before {
      position: absolute;
      content: '';
      top: -5px;
      left: -8px;
      width: 45px;
      height: 45px;
      background-image: url(${img});
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  ${props =>
    props.position === 'center' &&
    css`
      text-align: center;
    `};

  ${props =>
    props.position === 'left' &&
    css`
      text-align: left;
    `};
`



// WEBPACK FOOTER //
// ./src/components/Section/section.js